<template>
  <div class="content">
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                tableHeaderColor="purple"
                v-bind:title="$t('order_details_title')"
                sortBy="deliveryDate"
                sortOrder="asc"
                v-bind:subTitle="$t('order_details_subtitle', { order: this.subTitle })"
                v-bind:data="this.positions"
                v-bind:dict="this.positionsDict"
                hasCheckbox="true"
                v-bind:onSelectCheckbox="this.onSelectCheckbox"
        ></p-s-table>
      </div>
      <md-button class="md-primary" style="margin-left: auto; margin-right: 20px;" v-on:click="postItemsReceived()">{{ $t('confirm_delivery') }}</md-button>
    </div>
  </div>
</template>

<script>
import PSTable from "../components/Tables/PSTable";
import api from '@/api/api';
import store from '@/store/index.js';

export default {
  name: "ElProcSyDetails",
  components: { PSTable },
  data() {
    return {
      positions: [],
      selected: [],
      positionsDict: [
        { key: 'customerArticleNumber', label: 'table_header_customer_article_number', type: 'string'},
        { key: 'customerArticleDescription', label: 'table_header_customer_article_description', type: 'string'},
        { key: 'supplier', label: 'table_header_supplier', type: 'string'},
        { key: 'supplierArticleNumber', label: 'table_header_supplier_article_number', type: 'string'},
        { key: 'basePrice', label: 'table_header_base_price', type: 'price'},
        { key: 'quantity', label: 'table_header_quantity', type: 'number'},
        { key: 'price', label: 'table_header_total_price', type: 'price'},
        { key: 'confirmedDeliveryDate', label: 'table_header_confirmed_delivery_date', type: 'date'},
        { key: 'deliveryDate', label: 'table_header_arrival_date', type: 'date'}
      ]
    }
  },
  created() {
    this.pullData();
  },
  computed: {
    subTitle() {
      return this.$route.params.id;
    }
  },
  methods: {
    postItemsReceived() {
      api.postElProcSyOrders(this.selected).then(() => {
        this.pullData();
      });
    },
    pullData() {
      store.commit("setLoading", true);

      api.getElProcSyOrderDetails(this.$route.params.id).then((result) => {
        this.positions = result.data;

        store.commit("setLoading", false);
      });
    },
    onSelectCheckbox(val) {
      this.selected = val;
    }
  }
};
</script>

<style scoped>

</style>
